import type {
  DeviceType,
  AppStateRouteType,
  AppStateType,
  AppSidebarType,
} from "./modules/app";
import type { FundInfoType, MenuType, UserStateType } from "./modules/user";
import type { AppSettingsStateType } from "./modules/settings";
import type { AppEditorStateType } from "./modules/appEditor";
export interface StoreStateType {
  app: AppStateType;
  user: UserStateType;
  settings: AppSettingsStateType;
  appEditor: AppEditorStateType;
}
const getters = {
  sidebar: (state: StoreStateType): AppSidebarType => state.app.sidebar,
  pageLoading: (state: StoreStateType): boolean => state.app.pageLoading,
  device: (state: StoreStateType): DeviceType => state.app.device,
  route: (state: StoreStateType): AppStateRouteType => state.app.route,
  token: (state: StoreStateType): string => state.user.token,
  id: (state: StoreStateType): string => state.user.id,
  fundInfo: (state: StoreStateType): FundInfoType => state.user.fundInfo,
  userinfo: (state: StoreStateType): UserStateType => state.user,
  allMenus: (state: StoreStateType): MenuType[] => state.user.allMenus,
  roleMenus: (state: StoreStateType): MenuType[] => state.user.roleMenus,
  treeMenus: (state: StoreStateType): MenuType[] => state.user.treeMenus,
  appEditor: (state: StoreStateType): AppEditorStateType => state.appEditor,
  roleAndRouteMenus: (state: StoreStateType): MenuType[] =>
    state.user.roleAndRouteMenus,
  sumCustomerWithhold: (state: StoreStateType): number =>
    state.user.sumCustomerWithhold,
  collapseMenu: (state: StoreStateType): boolean => state.settings.collapseMenu,
  storeInfo: (state: StoreStateType): any => state.app.storeInfoData,
  subGroupId: (state: StoreStateType): string => state.user.subGroupId,
};
export default getters;
